import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Filtrer ut støy fra in-app-nettlesere (Snapchat, Instagram, TikTok, Messenger osv.)
// som injiserer egne JS-broer i sidene de åpner. Disse feilene har ingenting med
// applikasjonen vår å gjøre, men ville ellers utløst dev-overlayet i preview-modus.
//
// I tillegg dempes:
//   - AxiosError fra mislykte API-kall (håndteres separat av komponentene)
//   - "Request failed with status code …" (samme som over)
//   - "Network Error" (typisk under hot-reload av backend)
//   - "ResizeObserver loop limit exceeded" (kjent React/Chromium-støy)
// Disse feilene skal ikke krasje hele appen for sluttbrukeren.
const IN_APP_BRIDGE_PATTERNS = [
  /SCDynamic[A-Za-z]*Bridge/i,           // Snapchat
  /__fbnative_/i,                         // Facebook / Instagram / Messenger
  /webkit\.messageHandlers/i,             // generisk iOS WebView-injeksjon
  /TikTokJSBridge/i,                      // TikTok
  /chrome\.webview/i,                     // Windows WebView2
  /Request failed with status code/i,     // axios-feil (komponenter eier .catch())
  /Network Error/i,                       // axios under backend-hot-reload
  /AxiosError/i,                          // generisk axios-rejection
  /ResizeObserver loop/i,                 // kjent harmløs Chromium-støy
];
function isSilentNoise(msg) {
  const s = typeof msg === "string" ? msg : (msg && msg.message) || "";
  return IN_APP_BRIDGE_PATTERNS.some((re) => re.test(s));
}
window.addEventListener("error", (e) => {
  if (isSilentNoise(e.message || (e.error && e.error.message))) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const reason = e.reason && (e.reason.message || e.reason);
  if (isSilentNoise(reason)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrer service worker (PWA) – kun i produksjon, og hopp over i in-app-nettlesere.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch(() => {
        // Stille feil – PWA er fin-å-ha, ikke kritisk
      });
  });
}
